module.exports = __webpack_public_path__ + "static/media/Research.9a824916.jpg";